// Preset filter combos for sales / CSKH workflow.
// Each preset maps to a server-side filter body + optional sort mode.
// id is stable across releases — used as key when caching counts.

export const FILTER_ROLES = {
  SALES: "sales",
  CSKH: "cskh",
};

export const SALES_PRESETS = [
  {
    id: "sales_all",
    label: "Tất cả",
    icon: "Inbox",
    filters: {},
    sortMode: "recent",
  },
  {
    id: "sales_needs_reply",
    label: "Chưa phản hồi",
    icon: "Zap",
    filters: {
      // Contact where last_message_at > 1h ago and I haven't read.
      needsReplyMinutes: 60,
      categories: [],
    },
    sortMode: "recent",
  },
  {
    id: "sales_new_7d",
    label: "Khách mới (7 ngày)",
    icon: "Sparkles",
    filters: {
      // Pipeline stage "Mới" — resolved on client via pipelineStages list
      pipelineStageNames: ["Mới"],
    },
    sortMode: "recent",
  },
  {
    id: "sales_negotiating",
    label: "Đang đàm phán",
    icon: "Handshake",
    filters: {
      pipelineStageNames: ["Đàm phán", "Quan tâm"],
    },
    sortMode: "recent",
  },
  {
    id: "sales_closed",
    label: "Đã chốt",
    icon: "CheckCircle2",
    filters: {
      pipelineStageNames: ["Đã chốt"],
    },
    sortMode: "recent",
  },
  {
    id: "sales_birthday",
    label: "Sinh nhật",
    icon: "Cake",
    filters: {
      categories: ["birthday"],
    },
    sortMode: "recent",
  },
];

export const CSKH_PRESETS = [
  {
    id: "cskh_all",
    label: "Tất cả",
    icon: "Inbox",
    filters: {},
    sortMode: "recent",
  },
  {
    id: "cskh_unread",
    label: "Chưa đọc của tôi",
    icon: "Mail",
    filters: {
      categories: ["unread"],
    },
    sortMode: "unread_first",
  },
  {
    id: "cskh_waiting_1h",
    label: "Chờ > 1h",
    icon: "Clock",
    filters: {
      needsReplyMinutes: 60,
    },
    sortMode: "recent",
  },
  {
    id: "cskh_stranger",
    label: "Người lạ",
    icon: "UserPlus",
    filters: {
      categories: ["stranger"],
    },
    sortMode: "recent",
  },
  {
    id: "cskh_friend_request",
    label: "Lời mời kết bạn",
    icon: "UserCheck",
    filters: {
      categories: ["requesting"],
    },
    sortMode: "recent",
  },
];

export const PRESETS_BY_ROLE = {
  [FILTER_ROLES.SALES]: SALES_PRESETS,
  [FILTER_ROLES.CSKH]: CSKH_PRESETS,
};

/**
 * Resolve a preset to a concrete filter body (ready for shopApi.getContacts).
 * Converts pipelineStageNames -> pipelineStageIds using the provided stage list.
 */
export const resolvePresetFilters = (preset, pipelineStages = []) => {
  const out = { ...(preset.filters || {}) };
  if (Array.isArray(out.pipelineStageNames) && out.pipelineStageNames.length) {
    const ids = pipelineStages
      .filter((s) => out.pipelineStageNames.includes(s.name))
      .map((s) => s._id || s.id);
    out.pipelineStageIds = ids;
    delete out.pipelineStageNames;
  }
  if (preset.sortMode) out.sortMode = preset.sortMode;
  return out;
};
